import * as angular from 'angular';

import { TableListCell } from '../lib/table-list-cell';

class TableListHeaderController {
  private data!: TableListCell[];
  private dropdownEnabled = false;
  private hasLinks = false;
  private showHeader!: boolean;

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes['data']) {
      this.showHeader = this.hasData();
    }
  }

  hasData(): boolean {
    const isEmptyString = (v: unknown) => v === '';
    const isNullOrUndefined = (v: unknown) => v == null;
    const isValid = (d: TableListCell) => !isEmptyString(d.value.data) && !isNullOrUndefined(d.value.data);

    return this.data.some(isValid);
  }

  displayChevronSpacerColumn() {
    return this.hasLinks && !this.dropdownEnabled;
  }
}

export const TableListHeaderComponent: angular.IComponentOptions = {
  controller: TableListHeaderController,
  controllerAs: 'ctrl',
  bindings: {
    actionsEnabled: '<',
    data: '<',
    dropdownEnabled: '<',
    hasLinks: '<',
  },
  transclude: true,
  template: `
    <div class="row-wrapper" ng-transclude ng-if="ctrl.showHeader">
      <table-list-cell
        ng-repeat="cell in ctrl.data"
        column="{{cell.field}}"
        value="cell.value"
      />
      <table-list-cell column="actions" value="" ng-if="ctrl.actionsEnabled" />
      <table-list-cell column="dropdown" value="" ng-if="ctrl.dropdownEnabled" />
      <table-list-cell value="" ng-if="ctrl.displayChevronSpacerColumn()" />
    </div>
  `,
};
